import { assertNever } from '@varos/util-typescript';
import { z } from 'zod';
import { ContextFreePeriod } from '../../../../../../domain';
import { ReportDetailLoaderProps } from './reportDetailProps';

export const InstanceReportDetailParameterSchema = z.object({
    reportId: z.string(),
    source: z.string().optional(),
});
